import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { NavLink } from "react-router-dom"; import '../styles/footer.css';
import {
    BR_USERGUIDE_BUCKET_NAME
} from '../creds';
import {
  SIGNED_URL_API,
} from "../creds";
import axios from 'axios';

const CSL_USER_GUIDE = "TTR_CSL_User_Guide.pdf";
const OAG_USER_GUIDE = "TTR_OAG_User_Guide.pdf";
const BRB_USER_GUIDE = "TTR_BRB_User_Guide.pdf";
const MAC_USER_GUIDE = "TTR_MAC_User_Guide.pdf";
const TEA_TWB_USER_GUIDE = "TTR_TEA_TWB_User_Guide.pdf";

async function getPresignedAttachmentUrl(id, attachment) {
  try {
    //const objectKeys = attachments.map(attachment => `${id}/${attachment.Attachment_Name}`);
    console.log("getPresignedAttachmentUrl-->");
    console.log("id", id);
    console.log("attachment", attachment);
    const objectKeys = [];
    const objectKey = `${id}/${attachment}`;
    objectKeys.push(objectKey);
    console.log('objectKeys--->', objectKeys);
    const response = await axios.post(
      SIGNED_URL_API,
      { objectKeys },
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );
    const urlResponse = response.data.urls[0]
    console.log('getPresignedUrl--->', urlResponse);
    return urlResponse.presignedUrl;
  } catch (error) {
    console.error('Error in getPresignedUrl:', error);
    throw error;
  }
}

const content = (isLoggedIn, userRole) => {
    if(isLoggedIn === "False") {
        return (
            <div className='d-flex w-100 justify-content-center'>
                <NavLink className="nav-link px-2 app-nav-link d-flex align-items-center" to={"/contact"} target="_blank">
                    Contact Us
                </NavLink>
            </div>
        )
    }
    else {
        return (
            <div className='d-flex w-100 justify-content-center align-items-center'>
                <NavLink className="nav-link px-2 app-nav-link d-flex align-items-center" to={"/contact"} target="_blank">
                    Contact Us
                </NavLink>
                <NavLink className="nav-link px-2 app-nav-link d-flex align-items-center" target="_blank" 
                    to="#"
                    onClick={async (e) => {
                    e.preventDefault();
                    const url = await getPresignedAttachmentUrl(
                        BR_USERGUIDE_BUCKET_NAME,
                        "TTR_"+userRole+"_User_Guide.pdf"
                    );
                    window.open(url, '_blank');
                    }}>
                    User Guide
                </NavLink>
            </div>
        )
    }
}

const Footer = ( {isLoggedIn} ) => {
    const user = useSelector((state) => state.user);
    const [userRole, setUserRole] = useState("");
    const [userInformation, setInformation] = useState(null);
    useEffect(() => {

        setInformation(user.userinfo)

    }, [user]);
    useEffect(() => {
        if (userInformation) {
        setUserRole(userInformation?.role);
        }

    }, [userInformation]);
    return (
        <footer>
            {content(isLoggedIn, userRole)}
        </footer>
    )
}

export default Footer